import { Dialog, DialogContent } from '@/components/ui/dialog'
import { AdvertisementPage } from './AdvertisementPage'

interface AdvertisementDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  advertisementId?: number
  onRefresh?: () => void
}

export function AdvertisementDialog({
  open,
  onOpenChange,
  advertisementId,
  onRefresh,
}: AdvertisementDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[90vw] h-[90vh] max-w-[90vw] p-0 overflow-hidden">
        <AdvertisementPage
          advertisementId={advertisementId}
          onOpenChange={onOpenChange}
          onRefresh={onRefresh}
        />
      </DialogContent>
    </Dialog>
  )
}
